"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const UrlHelper_1 = require("src/ts/helpers/UrlHelper");
const MeetingContext_1 = require("../../../contexts/meetings/MeetingContext");
class GuestRedirect extends React.PureComponent {
    constructor() {
        super(...arguments);
        this._autoSubmit = (instance) => {
            if (instance) {
                instance.submit();
            }
        };
    }
    render() {
        return React.createElement(MeetingContext_1.MeetingContextConsumer, null, (meetingContext) => meetingContext && meetingContext.conversation &&
            React.createElement("form", { ref: this._autoSubmit, method: 'POST', action: UrlHelper_1.UrlHelper.getWebClientUrl({ threadId: meetingContext.conversation.resource }), style: { display: 'none' } },
                React.createElement("input", { type: 'hidden', name: 'skypetoken', value: this.props.skypetoken }),
                React.createElement("input", { type: 'hidden', name: 'expires_in', value: 24 * 3600 }),
                React.createElement("input", { type: 'hidden', name: 'state', value: meetingContext.csrfToken }),
                React.createElement("input", { type: 'hidden', name: 'skypeid', value: this.props.username })));
    }
}
exports.GuestRedirect = GuestRedirect;
